
import {
    createBrowserRouter
} from "react-router-dom";
import Menu from "./Pages/Menu";
import CheckOut from "./Pages/CheckOut";



const Navigation = createBrowserRouter([
    {
        path: '/',
        element: <Menu />
    },
    {
        path: '/carrinho',
        element: <CheckOut />
    },
]);


export default Navigation;